export default __webpack_public_path__ + "static/media/slide23.713f24a3.jpg";